export default __webpack_public_path__ + "static/media/au-act.45658151.svg";